import {
	REFRESH_RESUMES,
	SET_RESUMES,
	ADD_RESUME,
	UPDATE_RESUME,
	GET_RESUME,
	FINISH_GET_RESUME,
	DELETE_RESUME,
	SET_BIO_RESUME
} from './types';
import { removeDuplicateID } from 'utils/utils';

const initialState = {
	initialize: true,
	resumes: [],
	loadMore: true,
	limit: 11,
  	total: 0,
	isRequesting:false,
	bio:'',
	display_qr_reels:false,
};

const reducer = (state = initialState, {type, payload}) => {

	switch (type) {

		case REFRESH_RESUMES:
			return {
				...state,
				initialize: true,
				loadMore: true,
				resumes: [],
				isRequesting:false,
				total:0,
				display_qr_reels:false,
				limit: 11,
			}

		case SET_RESUMES:
			let newSetResume = [...state.resumes, ...payload.resumes]; //add resume and pagination purpose
			const filtered = removeDuplicateID(newSetResume);
			return {
				...state,
				initialize: false,
				resumes: [...filtered],
				total: payload.total,
				loadMore: payload.loadMore,
				isRequesting:false,
				display_qr_reels:payload?.display_qr_reels || false
			}

		case ADD_RESUME:
			let newSet = [...state.resumes, payload]; //add resume and pagination purpose
			const uniqueArray = removeDuplicateID(newSet);
			return {
				...state,
				resumes: uniqueArray
			}
		case GET_RESUME:
			return {
			...state,
			isRequesting: true,
			};
	
		case FINISH_GET_RESUME:
			return {
			...state,
			isRequesting: false,
			loadMore: payload.loadMore,
			};
		

		case UPDATE_RESUME:
			let updatedResumes = state.resumes.map((r, i) => {
				if (r.id === payload.id) {
					return payload
				}
				return r;
			});
			
			return {
				...state,
				resumes: updatedResumes
			}
		case DELETE_RESUME:
			let removedResumes = state.resumes.filter((r) =>  r.id !== payload.id);
			
			return {
				...state,
				resumes: removedResumes
			}
		case SET_BIO_RESUME:
			// console.log('-------------------')
			// console.log(payload);
			return {
				...state,
				bio: payload
			}

		default:
			return state;

	}

}

export default reducer